import CompliancePage from './Compliance';

export default CompliancePage;
